var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { shadowElevation2 } from '@hn-ui/themes';
import { BlueExternalLink } from '@hn-ui/links';
import Dino from '../../../../supervizors/components/marathons/images/banner-dino.svg';
import { Text, Title, } from '../../../../supervizors/components/marathons/Common';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-eknu82" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  border-radius: 16px;\n  background: ", ";\n  ", "\n  padding: 32px 32px 30px;\n  position: relative;\n"], ["\n  display: flex;\n  flex-flow: column;\n  border-radius: 16px;\n  background: ", ";\n  ", "\n  padding: 32px 32px 30px;\n  position: relative;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue95;
}, shadowElevation2);
var BannerTitle = styled(Title).withConfig({ displayName: "BannerTitle", componentId: "sc-sgqh7x" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 16px;\n"], ["\n  margin-bottom: 16px;\n"])));
var BannerText = styled(Text).withConfig({ displayName: "BannerText", componentId: "sc-ibkb5s" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 730px;\n"], ["\n  max-width: 730px;\n"])));
var BannerDino = styled(Dino).withConfig({ displayName: "BannerDino", componentId: "sc-1l05uys" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n"])));
var HelpLink = styled(BlueExternalLink).withConfig({ displayName: "HelpLink", componentId: "sc-1jtid9b" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  & > svg {\n    fill: ", ";\n  }\n"], ["\n  color: ", ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  & > svg {\n    fill: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var Banner = function (_a) {
    var rest = __rest(_a, []);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(BannerTitle, { children: "Introducing Math Challenges" }, void 0), _jsx(BannerText, { children: "4-week interclass competition designed to seamlessly install Happy Numbers into your teachers math routine. Boost implementation success and encourage regular usage to gain math growth." }, void 0), _jsx("br", {}, void 0), _jsxs(BannerText, { children: ["Dive deeper into the details by visiting our", ' ', _jsx(HelpLink, __assign({ href: 'https://help.happynumbers.com/en/collections/7260001-math-challenge', bold: true }, { children: "Help Center" }), void 0)] }, void 0), _jsx(BannerDino, {}, void 0)] }), void 0));
};
export { Banner };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
